// extracted by mini-css-extract-plugin
export var container = "ProductInfo_container__ujt9h";
export var imageContainer = "ProductInfo_imageContainer__ggVvL";
export var product = "ProductInfo_product__iQ4L4";
export var productDescription = "ProductInfo_productDescription__Xs--q";
export var unavailable = "ProductInfo_unavailable__2HInT";